webpackJsonp([26,35],{

/***/ 86:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(147),
	  /* template */
	  __webpack_require__(254),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 147:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _tabs = __webpack_require__(209);
	
	var _tabs2 = _interopRequireDefault(_tabs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'tabsdemo',
	  components: {
	    Tabs: _tabs2.default
	  },
	  methods: {
	    handleclick: function handleclick(item) {
	      this.content = item.alias;
	    }
	  },
	  data: function data() {
	    return {
	      content: 'like'
	    };
	  }
	};

/***/ }),

/***/ 148:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'tabs',
	  props: {
	    surface: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	    theme: {
	      type: String,
	      default: 'default' },
	    current: {
	      type: String,
	      default: ''
	    }
	  },
	  methods: {
	    setCurrent: function setCurrent(alias) {
	      this.current = alias;
	    },
	    handleClick: function handleClick(item) {
	      if (item.path) {
	        this.$router.push(item.path);
	      }
	      this.$emit('on-click', item);
	      this.setCurrent(item.alias);
	    }
	  },
	  data: function data() {
	    return {};
	  }
	};

/***/ }),

/***/ 209:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(148),
	  /* template */
	  __webpack_require__(262),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 254:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {}, [_c('tabs', {
	    attrs: {
	      "current": "like",
	      "theme": "dark",
	      "surface": [{
	        alias: 'like',
	        title: '收 藏'
	      }, {
	        alias: 'time',
	        title: '时光机'
	      }, {
	        alias: 'shop',
	        title: '小 摊'
	      }]
	    },
	    on: {
	      "on-click": _vm.handleclick
	    }
	  }), _vm._v(" "), _c('div', {
	    staticStyle: {
	      "font-size": "34px",
	      "padding-top": "130px",
	      "color": "#999"
	    }
	  }, [_vm._v("\n      " + _vm._s(_vm.content) + "\n    ")])], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 262:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "tabs-horizon tabs-horizon-flex",
	    class: ['tabs-horizon-' + _vm.theme]
	  }, _vm._l((_vm.surface), function(item, index) {
	    return _c('button', {
	      staticClass: "tabs-item",
	      class: [
	        item.alias == _vm.current ? 'tabs-item-current' : ''
	      ],
	      on: {
	        "click": function($event) {
	          _vm.handleClick(item, index)
	        }
	      }
	    }, [_vm._v("\n     " + _vm._s(item.title) + "\n  ")])
	  }))
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/26.1ba3b5dcdfb04c69f6d4.js